<template>
<div>
  <v-list-tile @click="$emit('click')">
    <v-list-tile-avatar>
      <h-icon></h-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>Tutorial</v-list-tile-content>
  </v-list-tile>
</div>
</template>

<script>
export default {};
</script>
